module.exports = __webpack_public_path__ + "static/media/S (23).714c0b45.jpg";